// Wejście do rejestru ośrodka ze strony badania: przycisk z licznikami (otwarte, do weryfikacji, poważne).
// Bez liczników (np. backend bez endpointu podsumowania) zostaje sam przycisk.
import { Link } from "react-router-dom";
import type { ResortIssueSummary } from "../../api/siteIssuesApi";

const Badge = ({ n, label, tone }: { n: number; label: string; tone: "amber" | "red" | "muted" }) => {
  const style = {
    amber: "bg-[var(--sc-amber-bg)] text-[#C07810]",
    red: "bg-[var(--sc-red-bg)] text-[var(--sc-red)]",
    muted: "bg-[var(--sc-bg)] text-[var(--sc-muted)]",
  }[tone];
  return (
    <span className={`inline-flex items-center rounded-full px-1.5 py-px text-[10px] font-medium whitespace-nowrap ${style}`}>
      {n} {label}
    </span>
  );
};

export const ResortRegisterButton = ({ resortId, summary }: { resortId: string; summary?: ResortIssueSummary }) => (
  <Link
    to={`/resorts/${resortId}/issues`}
    title="Znaleziska i akcje ośrodka przez całe badanie"
    className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-[8px] border border-[var(--sc-border)] bg-[var(--sc-surface)] px-2.5 py-1 text-[11px] font-medium text-[var(--sc-text)] no-underline shadow-sm transition-colors hover:border-[var(--sc-amber)] hover:bg-[var(--sc-amber-bg)]"
  >
    <svg aria-hidden width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6">
      <rect x="2.5" y="1.5" width="11" height="13" rx="1.5" />
      <path d="M5 5h6M5 8h6M5 11h4" strokeLinecap="round" />
    </svg>
    Rejestr ośrodka
    {summary && summary.total > 0 && (
      <span className="flex items-center gap-1">
        {summary.open > 0 ? <Badge n={summary.open} label="otwarte" tone="amber" /> : <Badge n={0} label="otwartych" tone="muted" />}
        {summary.needsReview > 0 && <Badge n={summary.needsReview} label="do weryfikacji" tone="red" />}
        {summary.seriousOpen > 0 && <Badge n={summary.seriousOpen} label="poważne" tone="red" />}
      </span>
    )}
    {summary && summary.total === 0 && <Badge n={0} label="pozycji" tone="muted" />}
  </Link>
);
